<template>
    <div class="offerDetailUserinfo" v-if="JSON.stringify(data)!=='{}'">
        <div class="title ben-000-color ben-size-16 ben-text-bold ben-border-t ">
            <p class="ben-ell-2">{{data.wantBuyAndDetails.title}}</p></div>
        <div class="infom-num ben-align-center ben-border-t ben-80-color ben-size-13">
            <van-row>
                <van-col span="8" class="num-list">
                    <p>采购预算</p>
                    <p class="ben-c41335-color ben-text-bold ben-size-14" :class="utils.loginState()==1?'':'ben-blur'">
                        <span class="ben-size-12" v-if="parseFloat(data.wantBuyAndDetails.total_amount)!==0">￥</span>
                        {{totalAmount}}
                        <span class="ben-size-12">{{totalAmountUnit}}</span>
                    </p>
                </van-col>
                <van-col span="8" class="num-list num-list-c">
                    <p>报价单数</p>
                    <p class="ben-c41335-color ben-text-bold ben-size-14">{{wantOfferCount}}<span class="ben-size-12">{{wantOfferCountUnit}}单</span></p>
                </van-col>
                <van-col span="8" class="num-list">
                    <p>剩余时间</p>
                    <p class="ben-c41335-color ben-text-bold ben-size-14">{{residueDays}}<span class="ben-size-12">天</span></p>
                </van-col>
            </van-row>
        </div>
        <div class="master-info">
            <van-row class="master-list ben-border-t">
                <van-col span="8" class="mas-l ben-000-color ben-size-14">联系人姓名</van-col>
                <van-col span="16" class="mas-r">
                    <div class="no-see ben-size-14 ben-be-color" v-if="!isWill">
                        <i class="el-icon-lock"></i>
                        采购方有意向后可见
                    </div>
                    <div v-else class="ben-000-color ben-size-14">
                        {{data.wantBuyAndDetails.contact_name}}
                    </div>
                </van-col>
            </van-row>
            <van-row class="master-list ben-border-t">
                <van-col span="8" class="mas-l ben-000-color ben-size-14">联系人电话</van-col>
                <van-col span="16" class="mas-r">
                    <div class="no-see ben-size-14 ben-be-color" v-if="!isWill">
                        <i class="el-icon-lock"></i>
                        采购方有意向后可见
                    </div>
                    <div v-else class="ben-000-color ben-size-14">
                        {{data.wantBuyAndDetails.contact_phone}}
                    </div>
                </van-col>
            </van-row>
            <van-row class="master-list ben-border-t">
                <van-col span="8" class="mas-l ben-000-color ben-size-14">交货地区</van-col>
                <van-col span="16" class="mas-r ben-000-color ben-size-14"> {{data.wantBuyAndDetails.province}} {{data.wantBuyAndDetails.city}} {{data.wantBuyAndDetails.area}} {{data.wantBuyAndDetails.address}} </van-col>
            </van-row>
            <van-row class="master-list ben-border-t">
                <van-col span="8" class="mas-l ben-000-color ben-size-14">发票需要</van-col>
                <van-col span="16" class="mas-r ben-000-color ben-size-14"> {{data.wantBuyAndDetails.invoice_requirement==0?"不需要发票":"需要发票"}} </van-col>
            </van-row>
            <van-row class="master-list ben-border-t">
                <van-col span="8" class="mas-l ben-000-color ben-size-14">发布时间</van-col>
                <van-col span="16" class="mas-r ben-000-color ben-size-14"> {{data.wantBuyAndDetails.updated_time}} </van-col>
            </van-row>
            <van-row class="master-list ben-border-t">
                <van-col span="8" class="mas-l ben-000-color ben-size-14">截至日期</van-col>
                <van-col span="16" class="mas-r ben-000-color ben-size-14"> {{data.wantBuyAndDetails.expiration_date.substr(0,10)}} </van-col>
            </van-row>
            <van-row class="master-list ben-border-t">
                <van-col span="8" class="mas-l ben-000-color ben-size-14">期望收货时间</van-col>
                <van-col span="16" class="mas-r ben-000-color ben-size-14"> {{data.wantBuyAndDetails.excepted_receving_date.substr(0,10)}} </van-col>
            </van-row>
        </div>
    </div>  
</template>
<script>
export default {
    name:'offerDetailUserinfo',
    components: {
    },
    props : {
        data : {
            type : Object
        }
    },
    data () {
        return {
            isWill : false,//是否有意向
            wantOfferCount : "",//报价单数
            wantOfferCountUnit : "",
            residueDays : "",//剩余时间
            totalAmount : "",//采购预算
            totalAmountUnit : "",
        }
    },
    created () {
        
    },
    watch : {
        data(){
           this.loading() 
           
        }
    },
    methods: {
        loading(){
            if(this.data.wantOffer){
                //offer_status 0初始化,1已提交,2有意向,3同意报价,4拒绝(报价不匹配),5报价过期,6取消报价,7已删除,8彻底删除
                if(this.data.wantOffer.offer_status===2||this.data.wantOffer.offer_status===3){
                    this.isWill = true
                }
            }
            //wantOfferCount
            let wantOfferCount = this.data.wantOfferCount
            if(wantOfferCount<1000){
                this.wantOfferCount = wantOfferCount
            }else if(1000<=wantOfferCount&&wantOfferCount<10000){
                this.wantOfferCount = this.utils.num_format(wantOfferCount,1)
            }else if(wantOfferCount>=10000){
                this.wantOfferCount = wantOfferCount/1000 ;
                this.wantOfferCountUnit = "W"
            }
            //residueDays
            let today = new Date().getTime()
            let zhtime = this.data.wantBuyAndDetails.expiration_date.split('-').join('/')
            let enddata = new Date(zhtime).getTime()
            let difftime = enddata - today
            let day = Math.ceil(difftime / 86400000)
            if (day < 0) {
                this.residueDays = 0
            } else {
                this.residueDays = day + 1
            }
            //budgetCount
            let totalAmount = (parseFloat(this.data.wantBuyAndDetails.total_amount)/100).toFixed(2)
            if(totalAmount==0){
                    this.totalAmount = "待报价"
                    this.totalAmountUnit = ""
            }else if(totalAmount<10000){
                this.totalAmount = totalAmount
                this.totalAmountUnit = ""
            }else if(totalAmount>=10000&&totalAmount<10000000){
                this.totalAmount = this.utils.num_format((totalAmount/10000).toFixed(2))
                this.totalAmountUnit = "W"
            }else if(totalAmount>=10000000&&totalAmount<100000000){
                this.totalAmount = this.utils.num_format((totalAmount/10000000).toFixed(2))
                this.totalAmountUnit = "千万"
            }else if(totalAmount>=100000000){
                this.totalAmount = this.utils.num_format((totalAmount/100000000).toFixed(2))
                this.totalAmountUnit = "亿"
            }

        }
    },
    mounted () {
        // this.loading()
    },
}

</script>


<style lang='scss' scoped>
.offerDetailUserinfo{
    background: #fff;
    margin-top: 5px;
    .master-info{
        .master-list{
            // height: 43px;
            line-height: 43px;
            padding: 0px 15px;

        }
    }
    .infom-num{
        .num-list{
            margin: 15px 0;
            p:first-child{
                margin-bottom: 5px;
            }
        }
        
        .num-list-c{
            border-left: 1px solid #eee;
            border-right: 1px solid #eee;
        }
    }
    .title{
        padding: 15px;
        
    }
}
</style>


// WEBPACK FOOTER //
// src/view/procurement/components/offerDetailUserinfo.vue